/* PROFILE */

import BasicLayout from '@/views/layouts/basic.vue';
import profileMyAccount from '@/views/profile/myAccount/details.vue';
import profileMyOrganization from '@/views/profile/myOrganization/details.vue';
import profileContacts from '@/views/profile/contacts/list.vue';
import profileContact from '@/views/profile/contacts/details.vue';
import profileUsers from '@/views/profile/users/list.vue';
import profileUser from '@/views/profile/users/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'profiel',
  name: 'profile',
  meta: {title: 'Profiel'},
  redirect: '/profiel/mijn-account',
  component: BasicLayout,
  children: [
    {
      path: 'mijn-account',
      name: 'profile.myAccount',
      meta: {title: 'mijn account'},
      component: profileMyAccount,
    },
    {
      path: 'mijn-organisatie',
      name: 'profile.myOrganization',
      meta: {title: 'mijn organisatie'},
      component: profileMyOrganization,
    },
    {
      path: 'contacten',
      name: 'profile.contacts',
      meta: {title: 'contacten'},
      component: profileContacts,
      children: [
        {
          path: ':status',
          name: 'profile.contacts.status',
          meta: {title: 'contacten'},
          component: profileContacts,
        },
      ],
    },
    {
      path: 'contact/:id/wijzigen',
      name: 'profile.contact.edit',
      meta: {title: 'contacten'},
      component: profileContact,
    },
    {
      path: 'contact/toevoegen',
      name: 'profile.contact.add',
      meta: {title: 'contacten'},
      component: profileContact,
    },
    {
      path: 'gebruikers',
      name: 'profile.users',
      meta: {title: 'gebruikers'},
      component: profileUsers,
      children: [
        {
          path: ':status',
          name: 'profile.users.status',
          meta: {title: 'gebruikers'},
          component: profileUsers,
        },
      ],
    },
    {
      path: 'gebruiker/:id/wijzigen',
      name: 'profile.user.edit',
      meta: {title: 'gebruikers'},
      component: profileUser,
    },
    {
      path: 'gebruiker/toevoegen',
      name: 'profile.user.add',
      meta: {title: 'gebruikers'},
      component: profileUser,
    },
  ],
};
